import React from 'react'

const LogoLine = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1" height="16" viewBox="0 0 1 16" fill="none" {...props}>
      <path d="M1 0H0V16H1V0Z" fill="currentColor" />
    </svg>
  )
}

export default LogoLine
